import BaseCardHandler from './BaseCardHandler';
import CardComponent from 'Component/Level/Card';
import CardSystem from '../CardSystem';
import SpriteComponent from 'Component/Render/Sprite';
import { ICardsState, ValueCardData } from 'State/Card/ICardState';
import { CardState } from 'Prototype/Level/Card/CardState';
import { IGameState } from 'State/Game/IGameState';
import BaseCard from 'Prototype/Level/Card/BaseCard';

export default class ValueCardHandler extends BaseCardHandler {
    public handleCardInPlay(state: ICardsState, cardSystem: CardSystem) {
        super.handleCardInPlay(state, cardSystem);

        const cardData = state.cards[this.card.id] as ValueCardData;

        // Value change.
        if (cardData.value !== this.cardComponent.value) {
            this.card.getChildByName(BaseCard.CARD_FRONT_NAME).getComponent(SpriteComponent).texture = `card${cardData.value +
                1}`;

            this.cardComponent.value = cardData.value;
        }
    }

    public handleCardFolded(state: IGameState, cardSystem: CardSystem) {
        super.handleCardFolded(state, cardSystem);
        this.clearModifiers();
    }

    public setCardFaceUp(faceUp: boolean) {
        super.setCardFaceUp(faceUp);

        if (this.card.getComponent(CardComponent).currentState === CardState.IN_PLAY) {
            this.card.updateModifiersVisibility(faceUp);
        } else {
            this.setCardModifiersVisible(false);
        }
    }
}
